import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function GolfNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Golf",
    links: [
      {href: "/golf", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

GolfNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default GolfNav



// WEBPACK FOOTER //
// ./modules/Golf/nav/GolfNav.js